export default __webpack_public_path__ + "static/media/caps.3c7db7be.wav";